import moment from 'moment';
import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import styled from 'styled-components';
import Loader from '../../../components/Loader';
import { baseUrl } from '../../../constants/environment';
import APIClient from '../../../helpers/APIClient';
import CalcUtils from '../../../helpers/CalcUltils';
import profilePic from '../../../assets/images/users/no-img.jpg';
import PriceUtils from '../../../helpers/PriceUtils';
const List = (props: any) => {
    const { id, componentRef, type } = props
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>({})
    console.log("dataPrint", id, data);

    useEffect(() => {
        if (id) {
            loadData()
        }
    }, [id]);

    const loadData = async () => {
        const url = `${baseUrl}/orders/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            setData(response.response)
        }
    }

    const calTotalPayment = ()=>{
        const total_payment = data?.orders_payment?.reduce((prevPay:any, itemPay:any)=>{
            prevPay = prevPay + Number(itemPay?.payment_total)
            return prevPay
        },0)
        return Math.floor(total_payment || 0)
    }

    return (
        <div className="print-content order-print" ref={componentRef}>
            <div className='modal-head m-0 p-3'>
                <h4 className='modal-title'>Hóa đơn bán hàng #{data?.code}</h4>
                <span className='modal-info'>{moment().format('HH:mm DD/MM/YYYY')}</span>
            </div>
            
            
            <div className="p-4">
                <div className="order-head">
                    <div className="head-avatar">
                        <img src={data?.branch_id?.avatar || profilePic}/>
                    </div>
                    <div className="head-info">
                        <div className="head-title">{data?.branch_id?.name}</div>
                        <div className="head-des">{data?.branch_id?.street}</div>
                    </div>
                </div>
                <div className='order-break'></div>
                <div className="order-row">
                    <div className="row-title">Tên khách hàng:</div>
                    <div className="row-value">{data?.customer_id?.name}</div>
                </div>
                <div className="order-row">
                    <div className="row-title">Địa chỉ:</div>
                    <div className="row-value">---</div>
                </div>
                <div className="order-row">
                    <div className="row-title">Ghi chú:</div>
                    <div className="row-value">{data?.customer_id?.note || '---'}</div>
                </div>
            </div>
            <div className="order-table">
                <div className="table-head">
                    <div className="table-head-value" style={{flex:4}}>Tên sản phẩm</div>
                    <div className="table-head-value" style={{flex:1}}>SL</div>
                    <div className="table-head-value" style={{flex:2}}>Đơn giá</div>
                    <div className="table-head-value" style={{flex:3}}>Thành tiền</div>
                </div>
                <div className="table-body">
                    {
                        data?.orders_products?.map((item: any, index: number) => {
                            const dataProduct = item?.variant_id ? {...item?.product_id, ...item?.variant_id} : item?.product_id
                            return(
                            <div className="table-row">
                                <div className="table-row-value" style={{flex:4}}>{dataProduct?.name}</div>
                                <div className="table-row-value" style={{flex:1}}>{PriceUtils.format(item?.quantity, '')}</div>
                                <div className="table-row-value" style={{flex:2}}>{PriceUtils.format(item?.price, '')}</div>
                                <div className="table-row-value" style={{flex:3}}>{PriceUtils.format(Number(item?.total), ' đ')}</div>
                                {/* <div className="table-row-value" style={{flex:3}}>{PriceUtils.format(Number(item?.total) - Number(item?.discount || 0), ' đ')}</div> */}
                            </div>)
                        })
                    }
                </div>
            </div>
            <div className="p-4">
                <div className="order-row">
                    <div className="order-title">Tổng tiền thanh toán</div>
                    <div className="order-value">{PriceUtils.format(data?.total || 0, "")}</div>
                </div>
                <div className="order-row">
                    <div className="row-title">Chiết khấu:</div>
                    <div className="row-value-bold">{PriceUtils.format(data?.discount || 0, "")}</div>
                </div>
                <div className="order-row">
                    <div className="row-title">Khách cần trả:</div>
                    <div className="row-value-bold"> {PriceUtils.format((data?.total || 0) - (data?.discount || 0),'')}</div>
                </div>
                <div className="order-row">
                    <div className="row-title">Tiền khách đưa:</div>
                    <div className="row-value-bold"> {PriceUtils.format(calTotalPayment(),'')}</div>
                </div>
                <div className="order-row">
                    <div className="row-title">Trả lại:</div>
                    <div className="row-value-bold">{PriceUtils.format(calTotalPayment() - ((data?.total || 0) - (data?.discount || 0)) > 0 ? calTotalPayment() - ((data?.total || 0) - (data?.discount || 0)) : 0,'')}</div>
                </div>
                <div className="order-row">
                    <div className="row-title">Công nợ hiện tại:</div>
                    <div className="row-value-bold">{PriceUtils.format(((data?.total || 0) - (data?.discount || 0)) - calTotalPayment(),'')}</div>
                </div>
                <div className='order-break'></div>
                <div className='order-thank'>Cảm ơn quý khách</div>
                
            </div>
            
            {
                loading && <Loader />
            }
        </div>
    )
}
export default List
